module.exports = __webpack_public_path__ + "media/top/icon_train_36x36-5c64bcc1.svg";